import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme, Box } from "@mui/material";
import AddressForm from "./address-form";
import Review from "./review";
import TopTabBar from "../../components/app-bar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { GetLocalStorage } from "../../utils/local-storage";
import { useEffect } from "react";

export const Checkout = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const checkOutData = GetLocalStorage("CheckOutData");
  useEffect(() => {
    let isPaymentSuccess = GetLocalStorage("isPaymentSuccess");
    if (isPaymentSuccess) {
      window.history.back();
    }
  }, []);
  return (
    <div>
      <TopTabBar
        backgroundColors={"#2f3138"}
        textColor={"#fff"}
        iconColor={"#2f3138"}
        boxShadow={"none"}
      />
      <section id="home">
        <div
          style={{
            backgroundImage: `url(${"https://eventprix.com/wp-content/uploads/2023/04/Add-to-Cart-Banner.jpg"})`,
            backgroundSize: isSmallScreen ? "cover" : "cover",
            height: isSmallScreen ? "30vh" : "45vh",
            width: "100%",
            position: "relative",
            backgroundAttachment: "fixed",
            transition: "background-image 0.5s ease-in-out",
          }}
        >
          <div
            style={{
              backgroundColor: "#000",
              opacity: 0.6,
              transition: "background 0.3s, border-radius 0.3s, opacity 0.3s",
              position: "relative",
              height: isSmallScreen ? "30vh" : "45vh",
            }}
          />
        </div>
      </section>
      <Grid
        container
        spacing={0}
        alignItems="center"
        justifyContent="center"
        position={"absolute"}
        top={0}
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height={isSmallScreen ? "10vh" : "calc(53vh - 55px)"}
            color="white"
            marginTop={isSmallScreen ? "130px" : "20px"}
          >
            <Typography
              style={{
                color: "#fff",
                fontFamily: "Poppins",
                fontWeight: 600,
                fontSize: isSmallScreen ? "30px" : "60px",
              }}
              align="center"
              variant="h1"
            >
              Checkout
            </Typography>
          </Box>
        </div>
      </Grid>
      <div
        style={{
          margin: "20px auto",
          maxWidth: "1520px",
          padding: "20px 0 20px 0",
        }}
      >
        <Grid container>
          {isSmallScreen ? (
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              style={{ padding: "0px 16px 0px 16px" }}
            >
              <Review data={checkOutData} />
            </Grid>
          ) : null}
          <Grid item xs={12} sm={12} md={8}>
            <Grid
              container
              spacing={3}
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Grid item xs={12}>
                <AddressForm />
              </Grid>
            </Grid>
          </Grid>
          {isSmallScreen ? null : (
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              style={{ padding: "0px 16px 0px 16px" }}
            >
              <Review data={checkOutData} />
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  );
};
